const BUYOUT_SOURCE = '/odkupime-nehnutelnost';
const APPROXIMATE_AREA_PATTERN = /^\d+(?:[.,]\d{1,2})?$/;

export type BuyoutPropertySummary = {
  propertyType: string;
  location: string;
  area: string;
  text: string;
};

export function isValidApproximateArea(value: string) {
  const normalizedValue = value.trim();

  return !normalizedValue || APPROXIMATE_AREA_PATTERN.test(normalizedValue);
}

export function buildBuyoutLeadMessage({
  propertyType,
  location,
  area,
  text,
}: BuyoutPropertySummary) {
  const approximateArea = area.trim() ? `${area.trim()} m²` : 'neuvedená';

  return [
    `Zdroj: ${BUYOUT_SOURCE}`,
    '',
    `Typ nehnuteľnosti: ${propertyType.trim()}`,
    `Lokalita: ${location.trim()}`,
    `Približná výmera: ${approximateArea}`,
    '',
    'Doplňujúce informácie:',
    text.trim(),
  ].join('\n');
}
